export const translations = {
  en: {
    // Nav
    nav_home: "Home",
    nav_courses: "Courses",
    nav_teachers: "Teachers",
    nav_prices: "Prices",
    nav_feedback: "Reviews",
    nav_enroll: "Enroll Now",

    // Hero
    hero_badge: "Premium Online Education",
    hero_title1: "Learn effectively.",
    hero_title2: "Achieve more.",
    hero_subtitle: "Expert-led courses in English, Math, Russian, Uzbek, German & Spanish. From IELTS to Westminster — your goals, our expertise.",
    stat1: "Students Enrolled",
    stat2: "Success Rate",
    stat3: "Teachers",
    stat4: "Courses Offered",

    // Sections
    what_we_teach: "What We Teach",
    our_courses: "Our Courses",
    // Counted from the catalogue, never typed — see tCoursesSubtitle. Russian
    // adds the three inflected forms below; `_plain` covers the moment before
    // the catalogue arrives, and the page description, written before any fetch.
    courses_subtitle: "{n} specialized programs designed for measurable results",
    courses_subtitle_plain: "Specialized programs designed for measurable results",
    who_teaches: "Who Teaches",
    meet_teachers: "Meet Our Teachers",
    teachers_subtitle: "Certified experts with international credentials and proven results",
    our_advantage: "Our Advantage",
    why_choose: "Why Choose SkillUp",
    why_subtitle: "What makes us different from every other online school",
    student_stories: "Student Stories",
    what_students_say: "What Our Students Say",
    get_started: "Get Started",
    ready_to: "Ready to SkillUp?",
    view_all: "View All Courses",
    all_teachers: "All Teachers →",

    // Why us
    why1_title: "Qualified Teachers",
    why1_desc: "We select teachers for their qualifications and teaching methodology. Every teacher has an open profile, so you know exactly who you will be studying with.",
    why2_title: "Modern Methodology",
    why2_desc: "We assess your level first, then build the programme around your goal — lessons follow a plan, not improvisation.",
    why3_title: "Engaging Lessons",
    why3_desc: "A lesson is built on active work: you speak, ask and practise, rather than sit and wait for it to end.",
    why4_title: "Individual Approach",
    why4_desc: "Groups are capped at 4 students, so the teacher sees how each one is doing and adjusts to it.",
    why5_title: "Progress Tracking",
    why5_desc: "Regular checks and feedback from lesson to lesson — you always know which stage you are at.",
    why6_title: "Academic Support",
    why6_desc: "Missed a lesson? You get a short one-to-one session to go through the material you missed.",
    why7_title: "Convenient Online Format",
    why7_desc: "Lessons run online — join from anywhere, with no travel and no dependence on where you live.",

    // Perks
    perk1: "Free trial lesson",
    perk2: "No commitment required",
    perk3: "We'll find the perfect course",

    // Trial lesson
    trial_tag: "Free Trial Lesson",
    trial_title: "What happens at the trial lesson",
    trial_subtitle: "A real lesson — free, and with no commitment.",
    trial_no_signup: "No sign-up and no account for the first lesson: leave a name and a number, we call you back and book it.",
    trial1: "You meet the teacher you would actually be studying with",
    trial2: "You take part in a real lesson, not a presentation",
    trial3: "The teacher works out your current level",
    trial4: "You see how the lessons are structured",
    trial5: "You can ask anything about the course, schedule and format",

    learn_more: "Learn More →",
    for_whom: "Who it's for:",
    view_program: "View Full Program →",
    view_profile: "View profile →",
    certifications: "Certifications",
    cd_duration: "Duration",
    cd_levels: "Levels",
    cd_formats: "Formats",
    cd_individual: "Individual",
    cd_enroll_note: "Enrol now, or start with a free trial lesson to try the course first.",
    exp_years: "{n} years of experience",
    age_from: "ages {n}+",
    age_range: "ages {min}–{max}",
    loading: "Loading...",
    course_not_found: "Course not found.",

    // Form
    your_name: "Your Name *",
    phone_number: "Phone Number *",
    select_course: "Select a course",
    message_opt: "Message (optional)",
    send_app: "Send Application →",
    name_placeholder: "Enter your full name",
    phone_placeholder: "+998 XX XXX XX XX",
    msg_placeholder: "Tell us about your goals...",
    form_error: "Please fill in all required fields.",

    // Course detail
    back_courses: "← Back to Courses",
    course_program: "Course Program",
    learning_formats: "Learning Formats",
    ready_start: "Ready to Start?",
    enroll_in: "Enrol in {name}",
    enroll_with: "Enrol with {name}",
    free_trial: "✓ Free trial lesson included",
    your_teachers: "Your Teachers",

    // Prices page
    transparent: "Transparent Pricing",
    simple_pricing: "Simple, Clear Pricing",
    pricing_subtitle: "Choose the format that fits your budget and learning style. All prices in UZS.",
    group_label: "Group",
    mini_group_label: "Mini-Group",
    individual_label: "Individual",
    group_desc: "Up to 4 students",
    mini_desc: "2 students · price per person",
    indiv_desc: "1-on-1 lesson",
    popular: "Popular",
    not_available: "Not available",
    note_ru_de_title: "Russian, Uzbek, German & Spanish",
    note_ru_de: "Russian and Uzbek are available in individual and mini-group formats. German and Spanish are individual only.",
    note_trial_title: "Free Trial Lesson",
    note_trial: "Free trial lesson available for all courses. Contact us to book your complimentary session.",
    note_home_title: "Home Tuition",
    note_home: "Lessons at your home can be arranged — terms are agreed individually with a manager.",
    note_packages_title: "Bundle Packages",
    note_packages: "Monthly packages available with discounts for pre-paid bundles. Ask about 3-month and 6-month deals.",
    still_not_sure: "Still not sure?",
    free_consult: "Book a free consultation with our team. We'll help you choose the right course and format.",
    get_free: "Get Free Consultation",
    course_col: "Course",

    // Feedback page
    feedback_tag: "Community Reviews",
    feedback_title: "Student Feedback",
    feedback_subtitle: "Real experiences from our students around the world",
    share_experience: "Share Your Experience",
    write_review: "Write a Review",
    your_review: "Your Review *",
    review_placeholder: "Tell us about your experience at SkillUp Academy...",
    your_rating: "Your Rating",
    submit_review: "Submit Review",
    review_success: "✓ Thank you! Your review has been submitted for approval.",
    no_reviews: "No approved reviews yet. Be the first to share your experience!",
    verified: "Verified Student",

    // Admin
    admin_title: "Admin Panel",
    admin_subtitle: "Manage applications, prices, teachers and courses",
    tab_applications: "📋 Applications",
    tab_prices: "💰 Prices",
    tab_teachers: "👨‍🏫 Teachers",
    tab_courses: "📚 Courses",
    tab_feedbacks: "💬 Reviews",
    tab_results: "🏆 Results",
    add_result: "+ Add Result",
    no_apps: "No applications yet.",
    edit: "✏️ Edit",
    save: "Save Changes",
    cancel: "Cancel",
    add_teacher: "+ Add Teacher",
    add_course: "+ Add Course",
    delete: "Delete",
    approve: "Approve",
    approved: "Approved",
    pending: "Pending",
    login_title: "Admin Login",
    login_subtitle: "Enter your credentials to access the admin panel",
    username: "Username",
    password: "Password",
    login_btn: "Login →",
    login_error: "Invalid username or password",
    logout: "Logout",

    // Nav — new pages
    nav_how: "How It Works",
    nav_faq: "FAQ",

    // Hero CTA (updated)
    hero_btn1: "Book a Free Trial Lesson",
    hero_btn2: "Check My Level",
    apply_subtitle_trial: "Fill in your details and we'll reach out within 24 hours to schedule your free trial lesson.",
    apply_subtitle_level: "Fill in your details and we'll reach out within 24 hours to schedule a quick level check with a teacher.",

    // Apply form — new fields
    your_age: "Age",
    age_placeholder: "e.g. 16",
    telegram_label: "Telegram / Messenger",
    telegram_placeholder: "@username or phone",
    format_label: "Learning Format",
    format_group: "Group",
    format_individual: "Individual",
    days_label: "Convenient Days",
    days_placeholder: "e.g. Mon, Wed, Fri",
    time_label: "Convenient Time",
    time_placeholder: "e.g. 18:00 – 19:00",
    form_success: "✓ Thank you! We've received your application. A SkillUp administrator will contact you to confirm the details and schedule your trial lesson.",

    // Results
    results_tag: "Real Results",
    results_title: "Student Results",
    results_subtitle: "Real outcomes achieved by our students",

    // How It Works page
    hiw_tag: "Our Methodology",
    hiw_title: "How SkillUp Works",
    hiw_subtitle: "From your first application to full access to your learning dashboard",
    hiw_method_title: "Our Methodology",
    hiw_method_p1: "Every student starts with a level assessment so lessons are matched to real ability, not guesswork.",
    hiw_method_p2: "Groups are formed by level and goal, so everyone in the room is working toward a similar target.",
    hiw_method_p3: "Teachers track progress lesson by lesson and give regular feedback, so you always know where you stand.",
    hiw_support_title: "Academic Support",
    hiw_support_intro: "We don't reschedule lessons, and there's no recalculation for a missed class — the group's schedule has to stay stable for everyone. But you're never left without help.",
    hiw_support_p1: "If you miss a lesson, you can book Academic Support — a focused 20–30 minute one-on-one session to go over what you missed, ask questions, and get back on track.",
    hiw_support_note: "Academic Support is a helping hand, not a full replacement for the missed lesson.",
    hiw_steps_title: "From Application to Your First Lesson",
    hiw_step1: "You submit an application",
    hiw_step2: "A SkillUp administrator contacts you",
    hiw_step3: "We match you to a course and schedule",
    hiw_step4: "You book a free trial lesson / level check",
    hiw_step5: "You meet your teacher and join a live lesson",
    hiw_step6: "We collect your feedback",
    hiw_step7: "If you'd like to continue, we set up enrolment",
    hiw_step8: "You sign the contract",
    hiw_step9: "Payment is made",
    hiw_step10: "You get access to learning and your personal dashboard",
    view_how: "See How It Works →",

    // FAQ page
    faq_tag: "Have Questions?",
    faq_title: "Frequently Asked Questions",
    faq_subtitle: "Everything you need to know before you start",
    view_faq: "View All Questions →",
    faq_q1: "From what age can I study?",
    faq_a1: "We welcome students across a wide range of ages — tell us your age and goal in the application, and we'll recommend the right course and format.",
    faq_q2: "Are there group lessons?",
    faq_a2: "Yes — group format is available for most courses. Group sizes are kept small for individual attention.",
    faq_q3: "Are there individual lessons?",
    faq_a3: "Yes, every course is available in an individual (1-on-1) format.",
    faq_q4: "How is my level determined?",
    faq_a4: "During your free trial lesson or level check, a teacher assesses your current level and recommends the right starting point.",
    faq_q5: "Is there a free trial lesson?",
    faq_a5: "Yes — every course includes a free trial lesson before you commit to anything.",
    faq_q6: "What happens after the trial lesson?",
    faq_a6: "You share your feedback with us. If you'd like to continue, we set up your enrolment, contract, and schedule.",
    faq_q7: "Can I reschedule a lesson?",
    faq_a7: "No — once your schedule is fixed at enrolment, lessons are not rescheduled, for group or individual formats. This keeps the group schedule stable for everyone.",
    faq_q8: "What happens if I miss a lesson?",
    faq_a8: "The lesson is considered held. You can book Academic Support — a focused 20–30 minute session to catch up on what you missed.",
    faq_q9: "What is Academic Support?",
    faq_a9: "A short one-on-one session (20–30 minutes) to review missed material and answer your questions. It's support, not a substitute for the full lesson.",
    faq_q10: "How does payment work?",
    faq_a10: "Payment details are confirmed with your administrator once your course and format are set, before your contract is signed.",
    faq_q11: "What is the contract term?",
    faq_a11: "The contract is signed for 12 months. That term is tracked separately from the lessons you pay for — a paid package is 12 lessons.",
    faq_q12: "Is there a freeze option?",
    faq_a12: "Freezing is not available for balances under 6 remaining lessons. Ask your administrator about your specific situation.",
    faq_q13: "Can I change my schedule?",
    faq_a13: "Your days and time are set when you enrol, based on what's convenient for you. Once fixed, the schedule doesn't change — plan your convenient days and time carefully at enrolment.",
    faq_q14: "How many lessons are in a paid package?",
    faq_a14: "A package is 12 lessons. That is not the same as the contract term: the contract runs for 12 months, while lessons are paid for and counted in packages of 12.",

    // Cabinet
    nav_cabinet: "Cabinet",
    nav_login: "Sign in",
    cab_login_title: "Sign in to your cabinet",
    cab_login_subtitle: "Students, parents, teachers and staff each have their own account.",
    login_email: "Email",
    login_identifier: "Email or phone number",
    login_identifier_hint: "Parents sign in with the phone number the office has for them. Everyone else uses their email.",
    login_password: "Password",
    login_submit: "Sign in",
    login_forgot: "Forgot your password?",
    login_forgot_help: "Passwords are issued by the academy office. Ask an administrator and they will set you a new one — no code, no waiting for email.",
    login_forgot_mail_help: "Enter the email address on your account and we will send a link for setting a new password.",
    login_forgot_submit: "Send the link",
    login_forgot_mailed: "If that address has an account, a link is on its way. It works for one hour.",
    login_reset_title: "New password",
    login_reset_help: "Choose a new password — at least 8 characters. Every other session on this account will be signed out.",
    login_reset_password: "New password",
    login_reset_repeat: "Repeat the password",
    login_reset_submit: "Save the password",
    login_reset_mismatch: "The two passwords do not match.",
    login_reset_short: "A password needs at least 8 characters.",
    login_reset_done: "Password changed. Sign in with the new one.",
    login_back: "Back to sign in",
    cab_hello: "Hello, {name}",
    cab_signout: "Sign out",
    cab_loading: "Loading...",
    cab_none: "Nothing here yet.",
    cab_tab_overview: "Overview",
    cab_tab_schedule: "Schedule",
    // The course cabinet: a lesson is the unit everything hangs off, so these
    // read as "what we did" and "what is next" rather than as record types.
    cab_tab_course: "My course",
    cab_tab_lessons: "Lessons",
    cab_lessons_hint: "Pick a group, then add the lesson you have just taught: what it was about, and who was there.",
    cab_lesson_add: "Add a lesson",
    cab_lesson_edit: "Edit",
    cab_lesson_topic: "Topic",
    cab_lesson_topic_hint: "e.g. Present Perfect",
    cab_lesson_summary: "What we covered",
    cab_lesson_summary_hint: "A couple of lines the student can read later",
    cab_lessons_past: "Lessons so far",
    cab_lessons_note: "Adding the same date again edits that lesson rather than creating a second one.",
    cab_next_lesson: "Next lesson",
    cab_you_were_here: "You were here",
    cab_you_missed: "You missed this one",
    cab_not_marked: "Not marked yet",
    cab_tab_homework: "Homework",
    cab_tab_attendance: "Attendance",
    cab_tab_payments: "Payments",
    cab_tab_groups: "Groups",
    cab_tab_students: "Students",
    cab_tab_finance: "Earnings",
    cab_tab_people: "People",
    cab_tab_log: "Activity log",
    cab_mail_title: "Password recovery mail",
    cab_mail_on: "On. Sender:",
    cab_mail_links: "links point to",
    cab_mail_off: "Off — passwords are set from the people tab. Not configured on the server:",
    cab_mail_off_short: "mail is off",
    cab_mail_test_sender: "The sender is on resend.dev, which is Resend's test address: mail reaches only the owner of the Resend account and is refused for everybody else. Verify your own domain and change MAIL_FROM.",
    cab_mail_no_attempts: "No recovery requests since the server last started.",
    cab_mail_sent: "Sent",
    cab_mail_failed: "The provider refused it:",
    cab_mail_no_account: "No active account on that address — nothing was sent",
    cab_tab_analytics: "Analytics",
    cab_tab_password: "Password",
    cab_tab_help: "Guide",
    cab_contract: "Contract",
    cab_contract_term: "12-month term",
    cab_package: "Lesson package",
    cab_package_note: "A package is 12 lessons. The contract term is counted separately.",
    cab_lessons_left: "Lessons left",
    cab_lessons_used: "Lessons used",
    cab_lessons_paid: "Lessons paid",
    cab_present: "Attended",
    cab_missed: "Missed",
    cab_no_reschedule: "Days and times are fixed at enrolment and are not rescheduled. A missed lesson counts as delivered - Academic Support is offered instead.",
    cab_due: "Due",
    cab_submit_answer: "Submit answer",
    cab_your_answer: "Your answer",
    cab_submitted: "Submitted",
    cab_grade: "Grade",
    cab_teacher_comment: "Teacher comment",
    cab_child: "Child",
    cab_parent_readonly: "You are viewing your child's cabinet. It is read-only.",
    cab_finance_net: "Shown after tax withholding",
    cab_finance_none: "No pay rate on file yet - ask the office.",
    cab_month: "Month",
    cab_lessons: "Lessons",
    cab_amount: "Amount",
    cab_date: "Date",
    cab_status: "Status",
    cab_name: "Name",
    cab_role: "Role",
    cab_email: "Email",
    cab_phone: "Phone",
    cab_parent_phone_note: "A parent signs in with their phone number — an email is optional for them.",
    cab_email_real_note: "The email has to be a working address: the domain is checked before the account is created.",
    cab_my_children: "My children",
    cab_no_children: "No child is linked to this account yet — the office does that.",
    cab_add: "Add",
    cab_save: "Save",
    cab_mark_present: "Present",
    cab_mark_missed: "Missed",
    cab_mark_note: "Marking a lesson uses one lesson from the package, present or missed.",
    cab_lesson_time: "Time",
    cab_lesson_course: "Course",
    cab_lesson_course_none: "Individual lesson",
    cab_scheduled_that_day: "On the timetable that day: {times}.",
    cab_mark_same_day_note: "A student can sit up to five lessons in one day, on different courses. Give each one its time — without it they are all the same lesson, and the second mark only corrects the first.",
    cab_mark_debt_note: "A student with two unpaid lessons is not admitted, and the lesson cannot be marked until the office records a payment.",
    cab_debt_title: "Unpaid",
    cab_debt_lessons: "{n} unpaid lessons",
    cab_debt_none: "Paid up",
    cab_debt_blocked: "Not admitted to lessons until this is paid.",
    cab_debt_not_admitted: "not admitted",
    cab_debt_warn: "{left} more unpaid lesson and the student is no longer admitted.",
    cab_current_password: "Current password",
    cab_new_password: "New password",
    cab_password_changed: "Password changed. Please sign in again.",
    cab_no_access: "This section is not available for your role.",
    cab_needs_login: "Please sign in to open your cabinet.",

    // Office cabinet
    cab_pick_student: "Student",
    cab_search: "Search",
    cab_delete: "Remove",
    cab_app_delete_confirm: "Delete for good",
    cab_cancel: "Cancel",
    nf_title: "This page does not exist",
    nf_text: "The address is wrong, or the page has moved. Nothing is broken — start again from one of these.",
    nf_home: "Home",
    nf_courses: "All courses",
    cab_tab_catalogue: "Catalogue",
    cab_edit: "Edit",
    cab_cat_courses: "Courses",
    cab_cat_teachers: "Teachers",
    cab_cat_prices: "Prices",
    cab_cat_reviews: "Reviews",
    cab_cat_results: "Results",
    cab_cat_live_note: "This is the public website. Anything saved here is visible to visitors straight away.",
    cab_cat_confirm_delete: "Yes, delete",
    cab_cat_add_course: "Add a course",
    cab_cat_edit_course: "Edit the course",
    cab_cat_title: "Title",
    cab_cat_category: "Category",
    cab_cat_icon: "Icon",
    cab_cat_duration: "Duration",
    cab_cat_levels: "Levels",
    cab_cat_price_individual: "Price, individual",
    cab_cat_description: "Description",
    cab_cat_audience: "Who it is for",
    cab_cat_program: "Programme, one item per line",
    cab_cat_formats: "Formats, one per line",
    cab_cat_note: "Note",
    cab_cat_add_teacher: "Add a teacher",
    cab_cat_edit_teacher: "Edit the profile",
    cab_cat_experience: "Experience",
    cab_cat_age_min: "Ages from",
    cab_cat_age_max: "Ages up to",
    cab_cat_age_max_hint: "no limit",
    cab_cat_photo: "Photo, link",
    cab_cat_subject: "Subject",
    cab_cat_education: "Education",
    cab_cat_short_bio: "Short biography, for the card",
    cab_cat_full_bio: "Full biography, for the profile",
    cab_cat_certifications: "Certificates, one per line",
    cab_cat_achievements: "Achievements, one per line",
    cab_cat_bio_note: "English is required: it is what a visitor sees when the Russian or Uzbek version has not been written yet. Certificates are not translated — they are the names of the certificates themselves.",
    cab_cat_missing_langs: "no {langs} yet",
    cab_cat_course: "Course",
    cab_cat_group: "Group",
    cab_cat_mini_group: "Mini-group",
    cab_cat_individual: "Individual",
    cab_cat_reviews_note: "A review is written by a visitor and stays hidden until it is published here.",
    cab_cat_published: "published",
    cab_cat_waiting: "waiting",
    cab_cat_publish: "Publish",
    cab_cat_results_note: "Real, verified results only — each one appears on the home page under the student's name.",
    cab_cat_add_result: "Add a result",
    cab_cat_result: "Result",
    cab_cat_certificate: "Certificate, link",
    cab_weekday: "Day",
    cab_time: "Time",
    cab_format: "Format",
    cab_teacher: "Teacher",
    cab_note: "Note",
    cab_start: "Start date",
    cab_lessons_count: "Lessons in the package",
    cab_parents: "Parents",
    cab_link_parent: "Link a parent",
    cab_rate_per_lesson: "Rate per lesson",
    cab_tax_percent: "Withholding, %",
    cab_group_name: "Group name",
    cab_members: "Members",
    cab_add_member: "Add a student",
    cab_set_password: "Set password",
    cab_format_group: "group",
    cab_format_individual: "individual",
    cab_saved: "Saved",
    cab_records: "Records",
    cab_no_student_picked: "Pick a student to see and edit their enrolment.",
    cab_rates: "Teacher pay",
    cab_contract_hint: "The end date follows from the start and the term — change either and it moves.",
    cab_contract_term_months: "Term, months",
    cab_months_short: "mo",
    cab_contract_price: "Price per month",
    cab_contract_discount: "Discount, %",
    cab_contract_per_week: "Lessons per week",
    cab_contract_per_month: "Lessons per month",
    cab_contract_note: "Note",
    cab_contract_due: "Payable monthly",
    cab_contract_edit: "Edit",
    cab_contract_save: "Save",
    cab_contract_cancel: "Cancel",
    cab_contract_not_set: "not agreed",
    cab_week_one: "× a week",
    cab_week_few: "× a week",
    cab_week_many: "× a week",
    cab_lesson_one: "lesson a month",
    cab_lesson_few: "lessons a month",
    cab_lesson_many: "lessons a month",
    cab_package_hint: "A package is 12 lessons by default. It is counted separately from the contract term.",

    // Password handover
    cab_show: "Show",
    cab_hide: "Hide",
    cab_copy: "Copy",
    cab_copied: "Copied",
    cab_generate: "Generate",
    cab_new_account: "Account created. Hand these over now — the password is stored one-way and cannot be read back later.",
    cab_password_note: "Passwords cannot be looked up afterwards, by anyone. If one is lost, set a new one here.",
    cab_account_for: "Account for",

    // Leavers
    cab_filter_all: "Everyone",
    cab_filter_active: "Still here",
    cab_filter_left: "Gone",
    cab_left: "gone",
    cab_active_children: "children here",
    cab_no_active_children: "no children here any more",
    cab_leaving_note: "Turning an account off is how someone leaves: they can no longer sign in and they drop off the teachers' lists, while payments, attendance and contracts stay on the record. Nothing is ever deleted, so a returning student picks up where they left off.",
    cab_parent_orphan_note: "Parents with no children here any more are worth turning off too.",
    cab_schedule_group: "Add for the whole group",

    // Applications
    cab_tab_applications: "Applications",
    cab_app_new: "New",
    cab_app_contacted: "Called",
    cab_app_enrolled: "Enrolled",
    cab_app_declined: "Declined",
    cab_app_trial: "Trial lesson",
    cab_app_phone: "Phone",
    cab_app_course: "Course",
    cab_app_wants: "Wants",
    cab_app_when: "Preferred days and time",
    cab_app_enrol: "Enrol this person",
    cab_app_handled_by: "handled by",
    cab_app_note: "How it went",
    cab_app_hint: "An application becomes a student here: enrolling creates the account and marks the application done. Everything after that is on the Students tab.",
    cab_app_created: "Student created and the application marked enrolled.",

    // Journal
    cab_tab_journal: "Journal",
    cab_journal_hint: "How this student is getting on: attendance, homework and remarks. Teachers, parents and the office see it; the student does not.",
    cab_notes: "Remarks",
    cab_add_note: "Add a remark",
    cab_note_text: "What to note",
    cab_note_private: "Remarks are not shown to the student.",
    cab_hw_done: "handed in",
    cab_hw_missing: "not handed in",
    cab_hw_set: "set",
    cab_journal_no_student: "No student to show yet.",
    cab_author: "by",

    // Website teachers
    cab_site_teachers: "Teachers on the website",
    cab_site_teachers_hint: "These are the profiles visitors see. A profile is not an account — link one to a cabinet user so the face on the site is the person who marks attendance.",
    cab_no_account: "no cabinet account",
    cab_linked_to: "linked to",
    cab_link: "Link",
  },

  ru: {
    nav_home: "Главная",
    nav_courses: "Курсы",
    nav_teachers: "Преподаватели",
    nav_prices: "Цены",
    nav_feedback: "Отзывы",
    nav_enroll: "Записаться",
    hero_badge: "Премиум онлайн-образование",
    hero_title1: "Учитесь эффективно.",
    hero_title2: "Достигайте большего.",
    hero_subtitle: "Экспертные курсы по английскому, математике, русскому, узбекскому, немецкому и испанскому. От IELTS до Westminster — ваши цели, наша экспертиза.",
    stat1: "Учеников обучено",
    stat2: "Успеваемость",
    stat3: "Преподавателей",
    stat4: "Курсов",
    what_we_teach: "Что мы преподаём",
    our_courses: "Наши курсы",
    courses_subtitle_plain: "Специализированные программы с измеримыми результатами",
    courses_subtitle_one: "{n} специализированная программа с измеримыми результатами",
    courses_subtitle_few: "{n} специализированные программы с измеримыми результатами",
    courses_subtitle_many: "{n} специализированных программ с измеримыми результатами",
    who_teaches: "Кто преподаёт",
    meet_teachers: "Наши преподаватели",
    teachers_subtitle: "Сертифицированные специалисты с международными дипломами и доказанными результатами",
    our_advantage: "Наши преимущества",
    why_choose: "Почему SkillUp",
    why_subtitle: "Что отличает нас от других онлайн-школ",
    student_stories: "Истории учеников",
    what_students_say: "Что говорят наши ученики",
    get_started: "Начать",
    ready_to: "Готовы к первому уроку?",
    view_all: "Все курсы",
    all_teachers: "Все преподаватели →",
    why1_title: "Квалифицированные преподаватели",
    why1_desc: "Мы отбираем преподавателей по квалификации и методике преподавания. Профиль каждого открыт — вы знаете, с кем будете заниматься.",
    why2_title: "Современная методика",
    why2_desc: "Сначала определяем уровень, потом строим программу под вашу цель — занятия идут по плану, а не наугад.",
    why3_title: "Вовлекающие занятия",
    why3_desc: "Урок построен на активной работе: вы говорите, спрашиваете и практикуетесь, а не ждёте его окончания.",
    why4_title: "Индивидуальный подход",
    why4_desc: "В группе не больше 4 человек — преподаватель видит, как идут дела у каждого, и подстраивается под это.",
    why5_title: "Контроль прогресса",
    why5_desc: "Регулярные проверки и обратная связь от урока к уроку — вы всегда понимаете, на каком этапе находитесь.",
    why6_title: "Academic Support",
    why6_desc: "Пропустили занятие — получаете короткую индивидуальную встречу, чтобы разобрать пропущенный материал.",
    why7_title: "Удобный онлайн-формат",
    why7_desc: "Занятия проходят онлайн: подключаетесь из любой точки, без дороги и привязки к району.",
    perk1: "Бесплатный пробный урок",
    perk2: "Без обязательств",
    perk3: "Подберём идеальный курс",

    // Пробный урок
    trial_tag: "Бесплатный пробный урок",
    trial_title: "Что будет на пробном уроке",
    trial_subtitle: "Настоящее занятие — бесплатно и без обязательств.",
    trial_no_signup: "На первый урок не нужна регистрация и аккаунт: оставьте имя и номер — мы перезвоним и запишем.",
    trial1: "Вы знакомитесь с преподавателем, с которым будете заниматься",
    trial2: "Участвуете в настоящем занятии, а не в презентации",
    trial3: "Преподаватель определяет ваш текущий уровень",
    trial4: "Вы видите, как устроены занятия",
    trial5: "Задаёте любые вопросы о курсе, расписании и формате",

    learn_more: "Подробнее →",
    for_whom: "Кому подходит:",
    view_program: "Смотреть программу →",
    view_profile: "Смотреть профиль →",
    certifications: "Сертификаты",
    cd_duration: "Длительность",
    cd_levels: "Уровни",
    cd_formats: "Форматы",
    cd_individual: "Индивидуально",
    cd_enroll_note: "Запишитесь или начните с бесплатного пробного урока, чтобы сначала попробовать курс.",
    exp_years_one: "{n} год опыта",
    loading: "Загрузка...",
    course_not_found: "Курс не найден.",
    exp_years_few: "{n} года опыта",
    exp_years_many: "{n} лет опыта",
    age_from_one: "от {n} года",
    age_from_few: "от {n} лет",
    age_from_many: "от {n} лет",
    age_range_one: "{min}–{max} год",
    age_range_few: "{min}–{max} года",
    age_range_many: "{min}–{max} лет",
    your_name: "Ваше имя *",
    phone_number: "Телефон *",
    select_course: "Выберите курс",
    message_opt: "Сообщение (необязательно)",
    send_app: "Отправить заявку →",
    name_placeholder: "Введите ваше имя",
    phone_placeholder: "+998 XX XXX XX XX",
    msg_placeholder: "Расскажите о ваших целях...",
    form_error: "Заполните все обязательные поля.",
    back_courses: "← Назад к курсам",
    course_program: "Программа курса",
    learning_formats: "Форматы обучения",
    ready_start: "Готовы начать?",
    enroll_in: "Записаться на {name}",
    enroll_with: "Записаться к {name}",
    free_trial: "✓ Бесплатный пробный урок",
    your_teachers: "Ваши преподаватели",
    transparent: "Прозрачные цены",
    simple_pricing: "Простые и понятные цены",
    pricing_subtitle: "Выберите формат, подходящий вашему бюджету. Все цены в сумах.",
    group_label: "Группа",
    mini_group_label: "Мини-группа",
    individual_label: "Индивидуальный",
    group_desc: "До 4 учеников",
    mini_desc: "2 ученика · цена за человека",
    indiv_desc: "1-на-1",
    popular: "Популярно",
    not_available: "Недоступно",
    note_ru_de_title: "Русский, узбекский, немецкий и испанский",
    note_ru_de: "Русский и узбекский доступны в индивидуальном и мини-групповом формате. Немецкий и испанский — только индивидуально.",
    note_trial_title: "Бесплатный пробный урок",
    note_trial: "Бесплатный пробный урок для всех курсов.",
    note_home_title: "Занятия с выездом на дом",
    note_home: "Обучение с выездом на дом возможно — условия обсуждаются индивидуально с менеджером.",
    note_packages_title: "Пакеты занятий",
    note_packages: "Доступны месячные пакеты со скидками.",
    still_not_sure: "Ещё сомневаетесь?",
    free_consult: "Запишитесь на бесплатную консультацию. Поможем выбрать курс.",
    get_free: "Бесплатная консультация",
    course_col: "Курс",
    feedback_tag: "Отзывы сообщества",
    feedback_title: "Отзывы учеников",
    feedback_subtitle: "Реальный опыт наших учеников со всего мира",
    share_experience: "Поделитесь опытом",
    write_review: "Написать отзыв",
    your_review: "Ваш отзыв *",
    review_placeholder: "Расскажите о вашем опыте в SkillUp Academy...",
    your_rating: "Ваша оценка",
    submit_review: "Отправить отзыв",
    review_success: "✓ Спасибо! Ваш отзыв отправлен на проверку.",
    no_reviews: "Пока нет одобренных отзывов. Станьте первым!",
    verified: "Проверенный ученик",
    admin_title: "Панель администратора",
    admin_subtitle: "Управление заявками, ценами, преподавателями и курсами",
    tab_applications: "📋 Заявки",
    tab_prices: "💰 Цены",
    tab_teachers: "👨‍🏫 Преподаватели",
    tab_courses: "📚 Курсы",
    tab_feedbacks: "💬 Отзывы",
    tab_results: "🏆 Результаты",
    add_result: "+ Добавить результат",
    no_apps: "Заявок пока нет.",
    edit: "✏️ Редактировать",
    save: "Сохранить",
    cancel: "Отмена",
    add_teacher: "+ Добавить преподавателя",
    add_course: "+ Добавить курс",
    delete: "Удалить",
    approve: "Одобрить",
    approved: "Одобрено",
    pending: "Ожидает",
    login_title: "Вход для администратора",
    login_subtitle: "Введите учётные данные для доступа к панели",
    username: "Имя пользователя",
    password: "Пароль",
    login_btn: "Войти →",
    login_error: "Неверное имя пользователя или пароль",
    logout: "Выйти",

    // Nav — новые страницы
    nav_how: "Как это работает",
    nav_faq: "Вопросы",

    // Hero CTA (обновлено)
    hero_btn1: "Записаться на пробный урок",
    hero_btn2: "Проверить уровень",
    apply_subtitle_trial: "Оставьте заявку — мы свяжемся в течение 24 часов и запишем вас на бесплатный пробный урок.",
    apply_subtitle_level: "Оставьте заявку — мы свяжемся в течение 24 часов и запишем вас на короткую проверку уровня с преподавателем.",

    // Форма заявки — новые поля
    your_age: "Возраст",
    age_placeholder: "например, 16",
    telegram_label: "Telegram / мессенджер",
    telegram_placeholder: "@username или телефон",
    format_label: "Формат обучения",
    format_group: "Групповой",
    format_individual: "Индивидуальный",
    days_label: "Удобные дни",
    days_placeholder: "например, Пн, Ср, Пт",
    time_label: "Удобное время",
    time_placeholder: "например, 18:00 – 19:00",
    form_success: "✓ Спасибо! Мы получили вашу заявку. Администратор SkillUp свяжется с вами для уточнения деталей и записи на пробный урок.",

    // Результаты
    results_tag: "Реальные результаты",
    results_title: "Результаты наших учеников",
    results_subtitle: "Реальные достижения наших учеников",

    // Страница «Как это работает»
    hiw_tag: "Наша методика",
    hiw_title: "Как проходит обучение в SkillUp",
    hiw_subtitle: "От первой заявки до полного доступа к личному кабинету",
    hiw_method_title: "Методика SkillUp",
    hiw_method_p1: "Каждый ученик начинает с определения уровня — чтобы занятия строились на реальных знаниях, а не наугад.",
    hiw_method_p2: "Группы формируются по уровню и цели, чтобы все в группе двигались к похожему результату.",
    hiw_method_p3: "Преподаватель отслеживает прогресс от урока к уроку и регулярно даёт обратную связь — вы всегда знаете, на каком этапе находитесь.",
    hiw_support_title: "Academic Support",
    hiw_support_intro: "Мы не переносим занятия, и перерасчёта за пропуск нет — расписание группы должно оставаться стабильным для всех. Но мы не оставляем ученика без поддержки.",
    hiw_support_p1: "Если вы пропустили занятие, вы можете воспользоваться Academic Support — это индивидуальная встреча на 20–30 минут, где преподаватель разбирает пропущенный материал и отвечает на вопросы.",
    hiw_support_note: "Academic Support — это поддержка, а не полноценная замена пропущенного урока.",
    hiw_steps_title: "От заявки до первого занятия",
    hiw_step1: "Вы оставляете заявку",
    hiw_step2: "Администратор SkillUp связывается с вами",
    hiw_step3: "Подбираем курс и расписание",
    hiw_step4: "Записываем на бесплатный пробный урок / проверку уровня",
    hiw_step5: "Вы знакомитесь с преподавателем и участвуете в занятии",
    hiw_step6: "Получаем вашу обратную связь",
    hiw_step7: "После подтверждения желания продолжить оформляем обучение",
    hiw_step8: "Подписывается договор",
    hiw_step9: "Производится оплата",
    hiw_step10: "Вы получаете доступ к обучению и личному кабинету",
    view_how: "Как проходит обучение →",

    // FAQ
    faq_tag: "Остались вопросы?",
    faq_title: "Часто задаваемые вопросы",
    faq_subtitle: "Всё, что нужно знать перед началом обучения",
    view_faq: "Все вопросы →",
    faq_q1: "С какого возраста можно обучаться?",
    faq_a1: "Мы принимаем учеников широкого возрастного диапазона — укажите возраст и цель в заявке, и мы подберём подходящий курс и формат.",
    faq_q2: "Есть ли групповые занятия?",
    faq_a2: "Да, групповой формат доступен для большинства курсов. Группы небольшие — для индивидуального внимания каждому.",
    faq_q3: "Есть ли индивидуальные занятия?",
    faq_a3: "Да, каждый курс доступен в индивидуальном формате (1-на-1).",
    faq_q4: "Как определить свой уровень?",
    faq_a4: "На бесплатном пробном уроке или проверке уровня преподаватель оценит ваш текущий уровень и порекомендует подходящую точку старта.",
    faq_q5: "Есть ли бесплатный пробный урок?",
    faq_a5: "Да — каждый курс включает бесплатный пробный урок до принятия решения об обучении.",
    faq_q6: "Что происходит после пробного урока?",
    faq_a6: "Вы делитесь обратной связью с нами. Если решите продолжить — оформляем зачисление, договор и расписание.",
    faq_q7: "Можно ли перенести занятие?",
    faq_a7: "Нет — после фиксации расписания при зачислении занятия не переносятся, ни в групповом, ни в индивидуальном формате. Это сохраняет стабильное расписание для всей группы.",
    faq_q8: "Что происходит при пропуске занятия?",
    faq_a8: "Занятие считается проведённым. Вы можете воспользоваться Academic Support — индивидуальной встречей на 20–30 минут, чтобы разобрать пропущенный материал.",
    faq_q9: "Что такое Academic Support?",
    faq_a9: "Короткая индивидуальная встреча (20–30 минут) для разбора пропущенного материала и ответов на вопросы. Это поддержка, а не замена полноценного урока.",
    faq_q10: "Как происходит оплата?",
    faq_a10: "Детали оплаты уточняются у администратора после выбора курса и формата, до подписания договора.",
    faq_q11: "На какой срок заключается договор?",
    faq_a11: "Договор заключается на 12 месяцев. Этот срок считается отдельно от оплаченных занятий — оплаченный пакет состоит из 12 занятий.",
    faq_q12: "Есть ли заморозка?",
    faq_a12: "Для случаев менее 6 оставшихся занятий заморозка не предусмотрена. Уточните свою ситуацию у администратора.",
    faq_q13: "Можно ли изменить расписание?",
    faq_a13: "Дни и время фиксируются при зачислении, исходя из ваших пожеланий. После фиксации расписание не меняется — выбирайте удобные дни и время внимательно на этапе зачисления.",
    faq_q14: "Сколько занятий в оплаченном пакете?",
    faq_a14: "Пакет — это 12 занятий. Это не то же самое, что срок договора: договор заключается на 12 месяцев, а занятия оплачиваются и считаются пакетами по 12.",

    // Кабинет
    nav_cabinet: "Кабинет",
    nav_login: "Войти",
    cab_login_title: "Вход в личный кабинет",
    cab_login_subtitle: "У ученика, родителя, преподавателя и администратора свой отдельный аккаунт.",
    login_email: "Электронная почта",
    login_identifier: "Почта или номер телефона",
    login_identifier_hint: "Родители входят по номеру телефона, который есть у администрации. Остальные — по электронной почте.",
    login_password: "Пароль",
    login_submit: "Войти",
    login_forgot: "Забыли пароль?",
    login_forgot_help: "Пароли выдаёт администрация академии. Обратитесь к администратору — он назначит вам новый пароль сразу, без кода и ожидания письма.",
    login_forgot_mail_help: "Укажите почту, на которую заведён кабинет, — пришлём ссылку для смены пароля.",
    login_forgot_submit: "Прислать ссылку",
    login_forgot_mailed: "Если такой адрес зарегистрирован, письмо уже в пути. Ссылка действует час.",
    login_reset_title: "Новый пароль",
    login_reset_help: "Придумайте новый пароль — не короче 8 символов. Все другие входы в этот кабинет будут завершены.",
    login_reset_password: "Новый пароль",
    login_reset_repeat: "Повторите пароль",
    login_reset_submit: "Сохранить пароль",
    login_reset_mismatch: "Пароли не совпадают.",
    login_reset_short: "Пароль должен быть не короче 8 символов.",
    login_reset_done: "Пароль изменён. Войдите с новым паролем.",
    login_back: "Вернуться ко входу",
    cab_hello: "Здравствуйте, {name}",
    cab_signout: "Выйти",
    cab_loading: "Загрузка...",
    cab_none: "Пока пусто.",
    cab_tab_overview: "Обзор",
    cab_tab_schedule: "Расписание",
    cab_tab_course: "Мой курс",
    cab_tab_lessons: "Уроки",
    cab_lessons_hint: "Выберите группу и добавьте проведённый урок: что разбирали и кто был.",
    cab_lesson_add: "Добавить урок",
    cab_lesson_edit: "Изменить",
    cab_lesson_topic: "Тема",
    cab_lesson_topic_hint: "например, Present Perfect",
    cab_lesson_summary: "Что разобрали",
    cab_lesson_summary_hint: "Пара строк, которые ученик прочитает потом",
    cab_lessons_past: "Прошедшие уроки",
    cab_lessons_note: "Если добавить ту же дату ещё раз, урок изменится, а не задвоится.",
    cab_next_lesson: "Ближайший урок",
    cab_you_were_here: "Вы были",
    cab_you_missed: "Вы пропустили",
    cab_not_marked: "Ещё не отмечено",
    cab_tab_homework: "Домашние задания",
    cab_tab_attendance: "Посещаемость",
    cab_tab_payments: "Оплаты",
    cab_tab_groups: "Группы",
    cab_tab_students: "Ученики",
    cab_tab_finance: "Начисления",
    cab_tab_people: "Люди",
    cab_tab_log: "Журнал действий",
    cab_mail_title: "Письма для восстановления пароля",
    cab_mail_on: "Включены. Отправитель:",
    cab_mail_links: "ссылки ведут на",
    cab_mail_off: "Выключены — пароли назначаются во вкладке «Люди». На сервере не задано:",
    cab_mail_off_short: "почта выключена",
    cab_mail_test_sender: "Отправитель на resend.dev — это тестовый адрес Resend: письма доходят только на почту владельца аккаунта Resend, всем остальным Resend их отклоняет. Подтвердите свой домен и поменяйте MAIL_FROM.",
    cab_mail_no_attempts: "С последнего запуска сервера восстановление никто не запрашивал.",
    cab_mail_sent: "Отправлено",
    cab_mail_failed: "Сервис отказал:",
    cab_mail_no_account: "На этот адрес не заведён активный аккаунт — письмо не отправлялось",
    cab_tab_analytics: "Аналитика",
    cab_tab_password: "Пароль",
    cab_tab_help: "Инструкция",
    cab_contract: "Договор",
    cab_contract_term: "срок 12 месяцев",
    cab_package: "Пакет занятий",
    cab_package_note: "Пакет — это 12 занятий. Срок договора считается отдельно.",
    cab_lessons_left: "Осталось занятий",
    cab_lessons_used: "Использовано",
    cab_lessons_paid: "Оплачено",
    cab_present: "Посещено",
    cab_missed: "Пропущено",
    cab_no_reschedule: "Дни и время фиксируются при зачислении и не переносятся. Пропущенное занятие считается проведённым — вместо него предлагается Academic Support.",
    cab_due: "Срок",
    cab_submit_answer: "Отправить ответ",
    cab_your_answer: "Ваш ответ",
    cab_submitted: "Отправлено",
    cab_grade: "Оценка",
    cab_teacher_comment: "Комментарий преподавателя",
    cab_child: "Ученик",
    cab_parent_readonly: "Вы смотрите кабинет своего ребёнка. Только просмотр.",
    cab_finance_net: "Указано за вычетом налога",
    cab_finance_none: "Ставка ещё не заведена — уточните у администратора.",
    cab_month: "Месяц",
    cab_lessons: "Занятий",
    cab_amount: "Сумма",
    cab_date: "Дата",
    cab_status: "Статус",
    cab_name: "Имя",
    cab_role: "Роль",
    cab_email: "Почта",
    cab_phone: "Телефон",
    cab_parent_phone_note: "Родитель входит по номеру телефона — почта для него необязательна.",
    cab_email_real_note: "Почта должна быть существующей: домен проверяется до создания аккаунта.",
    cab_my_children: "Мои дети",
    cab_no_children: "К этому аккаунту пока не привязан ни один ученик — это делает администрация.",
    cab_add: "Добавить",
    cab_save: "Сохранить",
    cab_mark_present: "Был",
    cab_mark_missed: "Пропустил",
    cab_mark_note: "Отметка занятия списывает одно занятие из пакета — и при посещении, и при пропуске.",
    cab_lesson_time: "Время",
    cab_lesson_course: "Курс",
    cab_lesson_course_none: "Индивидуальное занятие",
    cab_scheduled_that_day: "По расписанию в этот день: {times}.",
    cab_mark_same_day_note: "В один день у ученика может быть до пяти занятий, в том числе по разным курсам. Указывайте время каждого — без него это одно и то же занятие, и вторая отметка просто исправит первую.",
    cab_mark_debt_note: "Ученик с двумя неоплаченными занятиями на урок не допускается, и отметить занятие нельзя, пока администрация не проведёт оплату.",
    cab_debt_title: "Долг",
    cab_debt_lessons: "{n} неоплаченных занятий",
    cab_debt_none: "Оплачено",
    cab_debt_blocked: "Не допускается на занятия до оплаты.",
    cab_debt_not_admitted: "не допущен",
    cab_debt_warn: "Ещё {left} неоплаченное занятие — и ученика перестанут допускать.",
    cab_current_password: "Текущий пароль",
    cab_new_password: "Новый пароль",
    cab_password_changed: "Пароль изменён. Войдите заново.",
    cab_no_access: "Этот раздел недоступен для вашей роли.",
    cab_needs_login: "Войдите, чтобы открыть личный кабинет.",

    // Кабинет администратора
    cab_pick_student: "Ученик",
    cab_search: "Поиск",
    cab_delete: "Убрать",
    cab_app_delete_confirm: "Удалить насовсем",
    cab_cancel: "Отмена",
    nf_title: "Такой страницы нет",
    nf_text: "Адрес неверный или страница переехала. Ничего не сломалось — начните с одной из этих.",
    nf_home: "На главную",
    nf_courses: "Все курсы",
    cab_tab_catalogue: "Каталог",
    cab_edit: "Изменить",
    cab_cat_courses: "Курсы",
    cab_cat_teachers: "Преподаватели",
    cab_cat_prices: "Цены",
    cab_cat_reviews: "Отзывы",
    cab_cat_results: "Результаты",
    cab_cat_live_note: "Это публичный сайт. Всё, что здесь сохранено, посетители видят сразу.",
    cab_cat_confirm_delete: "Да, удалить",
    cab_cat_add_course: "Добавить курс",
    cab_cat_edit_course: "Изменить курс",
    cab_cat_title: "Название",
    cab_cat_category: "Категория",
    cab_cat_icon: "Значок",
    cab_cat_duration: "Длительность",
    cab_cat_levels: "Уровни",
    cab_cat_price_individual: "Цена, индивидуально",
    cab_cat_description: "Описание",
    cab_cat_audience: "Для кого",
    cab_cat_program: "Программа, по пункту в строке",
    cab_cat_formats: "Форматы, по одному в строке",
    cab_cat_note: "Примечание",
    cab_cat_add_teacher: "Добавить преподавателя",
    cab_cat_edit_teacher: "Изменить профиль",
    cab_cat_experience: "Опыт",
    cab_cat_age_min: "Возраст от",
    cab_cat_age_max: "Возраст до",
    cab_cat_age_max_hint: "без ограничения",
    cab_cat_photo: "Фото, ссылка",
    cab_cat_subject: "Предмет",
    cab_cat_education: "Образование",
    cab_cat_short_bio: "Краткая биография, для карточки",
    cab_cat_full_bio: "Полная биография, для профиля",
    cab_cat_certifications: "Сертификаты, по одному в строке",
    cab_cat_achievements: "Достижения, по одному в строке",
    cab_cat_bio_note: "Английский обязателен: именно его увидит посетитель, пока русская или узбекская версия не написана. Сертификаты не переводятся — это названия самих сертификатов.",
    cab_cat_missing_langs: "нет версии: {langs}",
    cab_cat_course: "Курс",
    cab_cat_group: "Группа",
    cab_cat_mini_group: "Мини-группа",
    cab_cat_individual: "Индивидуально",
    cab_cat_reviews_note: "Отзыв пишет посетитель сайта, и до публикации здесь его никто не видит.",
    cab_cat_published: "опубликован",
    cab_cat_waiting: "ожидает",
    cab_cat_publish: "Опубликовать",
    cab_cat_results_note: "Только настоящие, подтверждённые результаты — каждый появляется на главной странице с именем ученика.",
    cab_cat_add_result: "Добавить результат",
    cab_cat_result: "Результат",
    cab_cat_certificate: "Сертификат, ссылка",
    cab_weekday: "День",
    cab_time: "Время",
    cab_format: "Формат",
    cab_teacher: "Преподаватель",
    cab_note: "Примечание",
    cab_start: "Дата начала",
    cab_lessons_count: "Занятий в пакете",
    cab_parents: "Родители",
    cab_link_parent: "Привязать родителя",
    cab_rate_per_lesson: "Ставка за занятие",
    cab_tax_percent: "Удержание, %",
    cab_group_name: "Название группы",
    cab_members: "Состав",
    cab_add_member: "Добавить ученика",
    cab_set_password: "Задать пароль",
    cab_format_group: "группа",
    cab_format_individual: "индивидуально",
    cab_saved: "Сохранено",
    cab_records: "Записи",
    cab_no_student_picked: "Выберите ученика, чтобы посмотреть и изменить зачисление.",
    cab_rates: "Оплата преподавателям",
    cab_contract_hint: "Дата окончания считается из начала и срока — поменяете любое, сдвинется и она.",
    cab_contract_term_months: "Срок, месяцев",
    cab_months_short: "мес",
    cab_contract_price: "Цена за месяц",
    cab_contract_discount: "Скидка, %",
    cab_contract_per_week: "Занятий в неделю",
    cab_contract_per_month: "Уроков в месяц",
    cab_contract_note: "Примечание",
    cab_contract_due: "К оплате в месяц",
    cab_contract_edit: "Изменить",
    cab_contract_save: "Сохранить",
    cab_contract_cancel: "Отмена",
    cab_contract_not_set: "не оговорено",
    cab_week_one: "раз в неделю",
    cab_week_few: "раза в неделю",
    cab_week_many: "раз в неделю",
    cab_lesson_one: "урок в месяц",
    cab_lesson_few: "урока в месяц",
    cab_lesson_many: "уроков в месяц",
    cab_package_hint: "По умолчанию пакет — 12 занятий. Считается отдельно от срока договора.",

    // Передача пароля
    cab_show: "Показать",
    cab_hide: "Скрыть",
    cab_copy: "Скопировать",
    cab_copied: "Скопировано",
    cab_generate: "Придумать",
    cab_new_account: "Аккаунт создан. Передайте данные сейчас — пароль хранится необратимо и посмотреть его потом не получится.",
    cab_password_note: "Посмотреть пароль позже нельзя никому. Если он потерян — задайте здесь новый.",
    cab_account_for: "Аккаунт для",

    // Ушедшие
    cab_filter_all: "Все",
    cab_filter_active: "Занимаются",
    cab_filter_left: "Ушли",
    cab_left: "ушёл",
    cab_active_children: "детей занимается",
    cab_no_active_children: "дети больше не занимаются",
    cab_leaving_note: "Уход оформляется отключением аккаунта: человек больше не может войти и пропадает из списков преподавателей, а оплаты, посещаемость и договоры остаются в отчётности. Ничего не удаляется — если ученик вернётся, всё на месте.",
    cab_parent_orphan_note: "Родителей, у которых больше никто не занимается, тоже стоит отключить.",
    cab_schedule_group: "Поставить всей группе",

    // Заявки
    cab_tab_applications: "Заявки",
    cab_app_new: "Новая",
    cab_app_contacted: "Позвонили",
    cab_app_enrolled: "Зачислен",
    cab_app_declined: "Отказ",
    cab_app_trial: "Пробный урок",
    cab_app_phone: "Телефон",
    cab_app_course: "Курс",
    cab_app_wants: "Цель",
    cab_app_when: "Удобные дни и время",
    cab_app_enrol: "Завести ученика",
    cab_app_handled_by: "обработал",
    cab_app_note: "Как прошло",
    cab_app_hint: "Заявка превращается в ученика прямо здесь: кнопка создаёт аккаунт и помечает заявку зачисленной. Всё дальнейшее — во вкладке «Ученики».",
    cab_app_created: "Ученик создан, заявка помечена зачисленной.",

    // Журнал
    cab_tab_journal: "Журнал",
    cab_journal_hint: "Как идут дела у ученика: посещаемость, домашние задания и замечания. Видят преподаватель, родитель и администрация; сам ученик — нет.",
    cab_notes: "Замечания",
    cab_add_note: "Добавить замечание",
    cab_note_text: "Что отметить",
    cab_note_private: "Замечания ученику не показываются.",
    cab_hw_done: "сдано",
    cab_hw_missing: "не сдано",
    cab_hw_set: "задано",
    cab_journal_no_student: "Пока некого показать.",
    cab_author: "автор",

    // Преподаватели сайта
    cab_site_teachers: "Преподаватели на сайте",
    cab_site_teachers_hint: "Это карточки, которые видят посетители. Карточка — не аккаунт: свяжите её с пользователем кабинета, чтобы человек с сайта и тот, кто отмечает посещаемость, были одним лицом.",
    cab_no_account: "нет аккаунта в кабинете",
    cab_linked_to: "связан с",
    cab_link: "Связать",
  },

  uz: {
    nav_home: "Bosh sahifa",
    nav_courses: "Kurslar",
    nav_teachers: "O'qituvchilar",
    nav_prices: "Narxlar",
    nav_feedback: "Sharhlar",
    nav_enroll: "Ro'yxatdan o'tish",
    hero_badge: "Premium onlayn ta'lim",
    hero_title1: "Samarali o'rganing.",
    hero_title2: "Ko'proq erishing.",
    hero_subtitle: "Ingliz, matematika, rus, o'zbek, nemis va ispan tillarida ekspert darslar. IELTSdan Westminstergacha — sizning maqsadingiz, bizning tajribamiz.",
    stat1: "O'quvchilar",
    stat2: "Muvaffaqiyat darajasi",
    stat3: "O'qituvchilar",
    stat4: "Kurslar",
    what_we_teach: "Nima o'rgatamiz",
    our_courses: "Bizning kurslar",
    courses_subtitle: "O'lchanadigan natijalar uchun {n} ta ixtisoslashgan dastur",
    courses_subtitle_plain: "O'lchanadigan natijalar uchun ixtisoslashgan dasturlar",
    who_teaches: "Kim o'qitadi",
    meet_teachers: "O'qituvchilarimiz",
    teachers_subtitle: "Xalqaro sertifikatlangan ekspertlar, isbotlangan natijalar bilan",
    our_advantage: "Bizning afzalligimiz",
    why_choose: "Nima uchun SkillUp",
    why_subtitle: "Boshqa onlayn maktablardan nima bilan farq qilamiz",
    student_stories: "O'quvchi hikoyalari",
    what_students_say: "O'quvchilarimiz nima deydi",
    get_started: "Boshlash",
    ready_to: "SkillUpga tayyormisiz?",
    view_all: "Barcha kurslar",
    all_teachers: "Barcha o'qituvchilar →",
    why1_title: "Malakali o'qituvchilar",
    why1_desc: "O'qituvchilarni malakasi va dars berish metodikasi bo'yicha tanlaymiz. Har bir o'qituvchining profili ochiq — kim bilan shug'ullanishingizni bilasiz.",
    why2_title: "Zamonaviy metodika",
    why2_desc: "Avval darajangizni aniqlaymiz, so'ng maqsadingizga mos dastur tuzamiz — darslar reja asosida boradi.",
    why3_title: "Qiziqarli darslar",
    why3_desc: "Dars faol ishga qurilgan: siz gapirasiz, savol berasiz va mashq qilasiz, darsning tugashini kutib o'tirmaysiz.",
    why4_title: "Individual yondashuv",
    why4_desc: "Guruhda ko'pi bilan 4 o'quvchi — o'qituvchi har birining holatini ko'radi va shunga moslashadi.",
    why5_title: "Taraqqiyot nazorati",
    why5_desc: "Muntazam tekshiruv va darsdan darsga fikr-mulohaza — qaysi bosqichda ekaningizni doim bilasiz.",
    why6_title: "Academic Support",
    why6_desc: "Darsni o'tkazib yubordingizmi — o'tkazilgan mavzuni ko'rib chiqish uchun qisqa individual uchrashuv olasiz.",
    why7_title: "Qulay onlayn format",
    why7_desc: "Darslar onlayn o'tadi: istalgan joydan qo'shilasiz, yo'lga vaqt ketmaydi.",
    perk1: "Bepul sinov darsi",
    perk2: "Majburiyatsiz",
    perk3: "Ideal kursni topamiz",

    // Sinov darsi
    trial_tag: "Bepul sinov darsi",
    trial_title: "Sinov darsida nima bo'ladi",
    trial_subtitle: "Haqiqiy dars — bepul va hech qanday majburiyatsiz.",
    trial_no_signup: "Birinchi dars uchun ro'yxatdan o'tish va hisob kerak emas: ism va raqamni qoldiring — qo'ng'iroq qilib yozib qo'yamiz.",
    trial1: "Siz o'zingiz shug'ullanadigan o'qituvchi bilan tanishasiz",
    trial2: "Taqdimotda emas, haqiqiy darsda ishtirok etasiz",
    trial3: "O'qituvchi joriy darajangizni aniqlaydi",
    trial4: "Darslar qanday tuzilganini ko'rasiz",
    trial5: "Kurs, jadval va format haqida istalgan savolni berasiz",

    learn_more: "Batafsil →",
    for_whom: "Kimga mos:",
    view_program: "To'liq dasturni ko'rish →",
    view_profile: "Profilni ko'rish →",
    certifications: "Sertifikatlar",
    cd_duration: "Davomiyligi",
    cd_levels: "Darajalar",
    cd_formats: "Formatlar",
    cd_individual: "Individual",
    cd_enroll_note: "Yoziling yoki kursni sinab ko'rish uchun bepul sinov darsidan boshlang.",
    exp_years: "{n} yillik tajriba",
    age_from: "{n} yoshdan",
    age_range: "{min}–{max} yosh",
    loading: "Yuklanmoqda...",
    course_not_found: "Kurs topilmadi.",
    your_name: "Ismingiz *",
    phone_number: "Telefon raqami *",
    select_course: "Kursni tanlang",
    message_opt: "Xabar (ixtiyoriy)",
    send_app: "Ariza yuborish →",
    name_placeholder: "To'liq ismingizni kiriting",
    phone_placeholder: "+998 XX XXX XX XX",
    msg_placeholder: "Maqsadlaringiz haqida gapirib bering...",
    form_error: "Barcha majburiy maydonlarni to'ldiring.",
    back_courses: "← Kurslarga qaytish",
    course_program: "Kurs dasturi",
    learning_formats: "O'qish formatlari",
    ready_start: "Boshlashga tayyormisiz?",
    enroll_in: "{name} kursiga yozilish",
    enroll_with: "{name} bilan yozilish",
    free_trial: "✓ Bepul sinov darsi kiritilgan",
    your_teachers: "Sizning o'qituvchilaringiz",
    transparent: "Shaffof narxlar",
    simple_pricing: "Oddiy va aniq narxlar",
    pricing_subtitle: "Byudjetingizga mos formatni tanlang. Barcha narxlar so'mda.",
    group_label: "Guruh",
    mini_group_label: "Mini-guruh",
    individual_label: "Individual",
    group_desc: "4 tagacha o'quvchi",
    mini_desc: "2 o'quvchi · narx har bir kishi uchun",
    indiv_desc: "1-ga-1",
    popular: "Mashhur",
    not_available: "Mavjud emas",
    note_ru_de_title: "Rus, o'zbek, nemis va ispan tillari",
    note_ru_de: "Rus va o'zbek tillari individual va mini-guruh formatlarida mavjud. Nemis va ispan tillari faqat individual.",
    note_trial_title: "Bepul sinov darsi",
    note_trial: "Barcha kurslar uchun bepul sinov darsi mavjud.",
    note_home_title: "Uyga borib o'qitish",
    note_home: "Uyingizga borib dars o'tish mumkin — shartlar menejer bilan alohida kelishiladi.",
    note_packages_title: "Dars paketlari",
    note_packages: "Oldindan to'lov uchun chegirmali oylik paketlar mavjud.",
    still_not_sure: "Hali ishonchsizmi?",
    free_consult: "Jamoamiz bilan bepul maslahat uchun bog'laning.",
    get_free: "Bepul maslahat",
    course_col: "Kurs",
    feedback_tag: "Hamjamiyat sharhlari",
    feedback_title: "O'quvchi sharhlari",
    feedback_subtitle: "Dunyo bo'ylab o'quvchilarimizning haqiqiy tajribalari",
    share_experience: "Tajribangizni ulashing",
    write_review: "Sharh yozing",
    your_review: "Sharhingiz *",
    review_placeholder: "SkillUp Academydagi tajribangiz haqida gapirib bering...",
    your_rating: "Sizning bahongiz",
    submit_review: "Sharh yuborish",
    review_success: "✓ Rahmat! Sharhingiz ko'rib chiqish uchun yuborildi.",
    no_reviews: "Hali tasdiqlangan sharhlar yo'q. Birinchi bo'ling!",
    verified: "Tasdiqlangan o'quvchi",
    admin_title: "Admin paneli",
    admin_subtitle: "Arizalar, narxlar, o'qituvchilar va kurslarni boshqarish",
    tab_applications: "📋 Arizalar",
    tab_prices: "💰 Narxlar",
    tab_teachers: "👨‍🏫 O'qituvchilar",
    tab_courses: "📚 Kurslar",
    tab_feedbacks: "💬 Sharhlar",
    tab_results: "🏆 Natijalar",
    add_result: "+ Natija qo'shish",
    no_apps: "Hali arizalar yo'q.",
    edit: "✏️ Tahrirlash",
    save: "Saqlash",
    cancel: "Bekor qilish",
    add_teacher: "+ O'qituvchi qo'shish",
    add_course: "+ Kurs qo'shish",
    delete: "O'chirish",
    approve: "Tasdiqlash",
    approved: "Tasdiqlangan",
    pending: "Kutilmoqda",
    login_title: "Admin kirish",
    login_subtitle: "Admin paneliga kirish uchun ma'lumotlaringizni kiriting",
    username: "Foydalanuvchi nomi",
    password: "Parol",
    login_btn: "Kirish →",
    login_error: "Noto'g'ri foydalanuvchi nomi yoki parol",
    logout: "Chiqish",

    // Nav — yangi sahifalar
    nav_how: "Qanday ishlaydi",
    nav_faq: "Savollar",

    // Hero CTA (yangilangan)
    hero_btn1: "Bepul sinov darsiga yozilish",
    hero_btn2: "Darajamni tekshirish",
    apply_subtitle_trial: "Ma'lumotlaringizni kiriting — 24 soat ichida bog'lanib, bepul sinov darsiga yozamiz.",
    apply_subtitle_level: "Ma'lumotlaringizni kiriting — 24 soat ichida bog'lanib, o'qituvchi bilan qisqa daraja tekshiruviga yozamiz.",

    // Ariza shakli — yangi maydonlar
    your_age: "Yosh",
    age_placeholder: "masalan, 16",
    telegram_label: "Telegram / messenjer",
    telegram_placeholder: "@username yoki telefon",
    format_label: "O'qish formati",
    format_group: "Guruh",
    format_individual: "Individual",
    days_label: "Qulay kunlar",
    days_placeholder: "masalan, Dush, Chor, Juma",
    time_label: "Qulay vaqt",
    time_placeholder: "masalan, 18:00 – 19:00",
    form_success: "✓ Rahmat! Arizangizni oldik. SkillUp administratori tafsilotlarni aniqlashtirish va sinov darsiga yozish uchun siz bilan bog'lanadi.",

    // Natijalar
    results_tag: "Haqiqiy natijalar",
    results_title: "O'quvchilarimiz natijalari",
    results_subtitle: "O'quvchilarimizning haqiqiy yutuqlari",

    // «Qanday ishlaydi» sahifasi
    hiw_tag: "Bizning metodika",
    hiw_title: "SkillUp qanday ishlaydi",
    hiw_subtitle: "Birinchi arizadan shaxsiy kabinetga to'liq kirishgacha",
    hiw_method_title: "SkillUp metodikasi",
    hiw_method_p1: "Har bir o'quvchi daraja aniqlashdan boshlaydi — darslar taxminga emas, haqiqiy bilimga asoslanadi.",
    hiw_method_p2: "Guruhlar daraja va maqsadga qarab shakllantiriladi — guruhdagi hamma o'xshash natijaga intiladi.",
    hiw_method_p3: "O'qituvchi har darsdan keyin taraqqiyotni kuzatadi va muntazam fikr-mulohaza beradi — siz doim qayerda ekaningizni bilasiz.",
    hiw_support_title: "Academic Support",
    hiw_support_intro: "Biz darslarni ko'chirmaymiz va o'tkazib yuborilgan dars uchun qayta hisob-kitob qilmaymiz — guruh jadvali barcha uchun barqaror bo'lishi kerak. Lekin o'quvchini yordamsiz qoldirmaymiz.",
    hiw_support_p1: "Agar darsni o'tkazib yuborgan bo'lsangiz, Academic Support xizmatidan foydalanishingiz mumkin — bu 20–30 daqiqalik individual uchrashuv bo'lib, unda o'tkazib yuborilgan material ko'rib chiqiladi va savollaringizga javob beriladi.",
    hiw_support_note: "Academic Support — bu yordam, o'tkazib yuborilgan darsning to'liq o'rnini bosuvchi narsa emas.",
    hiw_steps_title: "Arizadan birinchi darsgacha",
    hiw_step1: "Siz ariza qoldirasiz",
    hiw_step2: "SkillUp administratori siz bilan bog'lanadi",
    hiw_step3: "Kurs va jadvalni tanlaymiz",
    hiw_step4: "Bepul sinov darsi / daraja tekshiruviga yozamiz",
    hiw_step5: "O'qituvchingiz bilan tanishasiz va darsda qatnashasiz",
    hiw_step6: "Fikr-mulohazangizni olamiz",
    hiw_step7: "Davom ettirishni xohlasangiz, ro'yxatdan o'tkazamiz",
    hiw_step8: "Shartnoma imzolanadi",
    hiw_step9: "To'lov amalga oshiriladi",
    hiw_step10: "Ta'lim va shaxsiy kabinetga kirish huquqini olasiz",
    view_how: "Qanday ishlashini ko'rish →",

    // FAQ
    faq_tag: "Savollaringiz bormi?",
    faq_title: "Ko'p beriladigan savollar",
    faq_subtitle: "O'qishni boshlashdan oldin bilishingiz kerak bo'lgan hamma narsa",
    view_faq: "Barcha savollar →",
    faq_q1: "Necha yoshdan o'qish mumkin?",
    faq_a1: "Biz turli yoshdagi o'quvchilarni qabul qilamiz — arizada yoshingiz va maqsadingizni ko'rsating, biz mos kurs va formatni tavsiya qilamiz.",
    faq_q2: "Guruh darslari bormi?",
    faq_a2: "Ha, ko'pchilik kurslar uchun guruh formati mavjud. Guruhlar kichik — har biriga alohida e'tibor uchun.",
    faq_q3: "Individual darslar bormi?",
    faq_a3: "Ha, har bir kurs individual (1-ga-1) formatda ham mavjud.",
    faq_q4: "Darajam qanday aniqlanadi?",
    faq_a4: "Bepul sinov darsi yoki daraja tekshiruvida o'qituvchi joriy darajangizni baholaydi va mos boshlang'ich nuqtani tavsiya qiladi.",
    faq_q5: "Bepul sinov darsi bormi?",
    faq_a5: "Ha — har bir kurs qaror qabul qilishdan oldin bepul sinov darsini o'z ichiga oladi.",
    faq_q6: "Sinov darsidan keyin nima bo'ladi?",
    faq_a6: "Siz fikr-mulohazangizni bizga bildirasiz. Davom ettirishni xohlasangiz, ro'yxatga olish, shartnoma va jadvalni rasmiylashtiramiz.",
    faq_q7: "Darsni ko'chirish mumkinmi?",
    faq_a7: "Yo'q — ro'yxatdan o'tishda jadval belgilangach, darslar guruh yoki individual formatda ham ko'chirilmaydi. Bu butun guruh uchun barqaror jadvalni saqlaydi.",
    faq_q8: "Darsni o'tkazib yuborsam nima bo'ladi?",
    faq_a8: "Dars o'tkazilgan hisoblanadi. Siz Academic Support xizmatidan foydalanishingiz mumkin — o'tkazib yuborilgan materialni ko'rib chiqish uchun 20–30 daqiqalik uchrashuv.",
    faq_q9: "Academic Support nima?",
    faq_a9: "O'tkazib yuborilgan materialni ko'rib chiqish va savollaringizga javob berish uchun qisqa individual uchrashuv (20–30 daqiqa). Bu yordam, to'liq darsning o'rnini bosuvchi narsa emas.",
    faq_q10: "To'lov qanday amalga oshiriladi?",
    faq_a10: "To'lov tafsilotlari kurs va format tanlangach, shartnoma imzolanishidan oldin administrator bilan aniqlashtiriladi.",
    faq_q11: "Shartnoma qancha muddatga tuziladi?",
    faq_a11: "Shartnoma 12 oyga tuziladi. Bu muddat to'langan darslardan alohida hisoblanadi — to'langan paket 12 ta darsdan iborat.",
    faq_q12: "Muzlatish imkoniyati bormi?",
    faq_a12: "Qolgan darslar soni 6 tadan kam bo'lsa, muzlatish ko'zda tutilmagan. Vaziyatingizni administrator bilan aniqlashtiring.",
    faq_q13: "Jadvalni o'zgartirish mumkinmi?",
    faq_a13: "Kunlar va vaqt ro'yxatdan o'tishda, sizga qulay tarzda belgilanadi. Belgilangach, jadval o'zgarmaydi — ro'yxatdan o'tish bosqichida qulay kun va vaqtni diqqat bilan tanlang.",
    faq_q14: "To'langan paketda nechta dars bor?",
    faq_a14: "Paket — 12 ta dars. Bu shartnoma muddati bilan bir xil emas: shartnoma 12 oyga tuziladi, darslar esa 12 tadan paket bo'lib to'lanadi va hisoblanadi.",

    // Kabinet
    nav_cabinet: "Kabinet",
    nav_login: "Kirish",
    cab_login_title: "Shaxsiy kabinetga kirish",
    cab_login_subtitle: "O‘quvchi, ota-ona, o‘qituvchi va administratorning alohida hisobi bor.",
    login_email: "Elektron pochta",
    login_identifier: "Pochta yoki telefon raqami",
    login_identifier_hint: "Ota-onalar ma‘muriyatdagi telefon raqami bilan kiradi. Qolganlar — elektron pochta bilan.",
    login_password: "Parol",
    login_submit: "Kirish",
    login_forgot: "Parolni unutdingizmi?",
    login_forgot_help: "Parollarni akademiya ma’muriyati beradi. Administratorga murojaat qiling — u sizga darhol yangi parol belgilaydi, kodsiz va xatni kutmasdan.",
    login_forgot_mail_help: "Kabinet ochilgan pochta manzilini kiriting — parolni almashtirish havolasini yuboramiz.",
    login_forgot_submit: "Havolani yuborish",
    login_forgot_mailed: "Agar bu manzil ro‘yxatdan o‘tgan bo‘lsa, xat yo‘lda. Havola bir soat amal qiladi.",
    login_reset_title: "Yangi parol",
    login_reset_help: "Yangi parol o‘ylab toping — kamida 8 belgi. Bu kabinetdagi boshqa barcha seanslar yakunlanadi.",
    login_reset_password: "Yangi parol",
    login_reset_repeat: "Parolni takrorlang",
    login_reset_submit: "Parolni saqlash",
    login_reset_mismatch: "Parollar mos kelmadi.",
    login_reset_short: "Parol kamida 8 belgidan iborat bo‘lishi kerak.",
    login_reset_done: "Parol o‘zgartirildi. Yangi parol bilan kiring.",
    login_back: "Kirishga qaytish",
    cab_hello: "Assalomu alaykum, {name}",
    cab_signout: "Chiqish",
    cab_loading: "Yuklanmoqda...",
    cab_none: "Hozircha bo‘sh.",
    cab_tab_overview: "Umumiy",
    cab_tab_schedule: "Dars jadvali",
    cab_tab_course: "Mening kursim",
    cab_tab_lessons: "Darslar",
    cab_lessons_hint: "Guruhni tanlang va o'tkazilgan darsni qo'shing: nima o'tildi va kim bor edi.",
    cab_lesson_add: "Dars qo'shish",
    cab_lesson_edit: "O'zgartirish",
    cab_lesson_topic: "Mavzu",
    cab_lesson_topic_hint: "masalan, Present Perfect",
    cab_lesson_summary: "Nimani o'tdik",
    cab_lesson_summary_hint: "O'quvchi keyin o'qiydigan bir-ikki qator",
    cab_lessons_past: "O'tilgan darslar",
    cab_lessons_note: "Xuddi shu sana qayta qo'shilsa, dars ikkilanmaydi — o'sha dars o'zgaradi.",
    cab_next_lesson: "Keyingi dars",
    cab_you_were_here: "Siz bor edingiz",
    cab_you_missed: "Siz qoldirdingiz",
    cab_not_marked: "Hali belgilanmagan",
    cab_tab_homework: "Uyga vazifa",
    cab_tab_attendance: "Davomat",
    cab_tab_payments: "To‘lovlar",
    cab_tab_groups: "Guruhlar",
    cab_tab_students: "O‘quvchilar",
    cab_tab_finance: "Hisob-kitob",
    cab_tab_people: "Foydalanuvchilar",
    cab_tab_log: "Amallar jurnali",
    cab_mail_title: "Parolni tiklash xatlari",
    cab_mail_on: "Yoqilgan. Jo‘natuvchi:",
    cab_mail_links: "havolalar manzili —",
    cab_mail_off: "O‘chirilgan — parollar «Odamlar» bo‘limida beriladi. Serverda belgilanmagan:",
    cab_mail_off_short: "pochta o‘chirilgan",
    cab_mail_test_sender: "Jo‘natuvchi resend.dev da — bu Resend’ning sinov manzili: xatlar faqat Resend hisobi egasiga yetadi, qolganlarga Resend ularni rad etadi. O‘z domeningizni tasdiqlang va MAIL_FROM ni o‘zgartiring.",
    cab_mail_no_attempts: "Server oxirgi ishga tushgandan beri hech kim tiklashni so‘ramadi.",
    cab_mail_sent: "Yuborildi",
    cab_mail_failed: "Xizmat rad etdi:",
    cab_mail_no_account: "Bu manzilda faol hisob yo‘q — xat yuborilmadi",
    cab_tab_analytics: "Tahlil",
    cab_tab_password: "Parol",
    cab_tab_help: "Qo‘llanma",
    cab_contract: "Shartnoma",
    cab_contract_term: "muddati 12 oy",
    cab_package: "Darslar paketi",
    cab_package_note: "Paket — 12 ta dars. Shartnoma muddati alohida hisoblanadi.",
    cab_lessons_left: "Qolgan darslar",
    cab_lessons_used: "Ishlatilgan",
    cab_lessons_paid: "To‘langan",
    cab_present: "Qatnashgan",
    cab_missed: "Qoldirilgan",
    cab_no_reschedule: "Kun va vaqt qabul paytida belgilanadi va ko‘chirilmaydi. Qoldirilgan dars o‘tilgan hisoblanadi — uning o‘rniga Academic Support taklif qilinadi.",
    cab_due: "Muddat",
    cab_submit_answer: "Javobni yuborish",
    cab_your_answer: "Sizning javobingiz",
    cab_submitted: "Yuborildi",
    cab_grade: "Baho",
    cab_teacher_comment: "O‘qituvchi izohi",
    cab_child: "O‘quvchi",
    cab_parent_readonly: "Siz farzandingiz kabinetini ko‘rmoqdasiz. Faqat ko‘rish uchun.",
    cab_finance_net: "Soliq ushlab qolingandan keyin",
    cab_finance_none: "Stavka hali kiritilmagan — administratordan so‘rang.",
    cab_month: "Oy",
    cab_lessons: "Darslar",
    cab_amount: "Summa",
    cab_date: "Sana",
    cab_status: "Holat",
    cab_name: "Ism",
    cab_role: "Rol",
    cab_email: "Pochta",
    cab_phone: "Telefon",
    cab_parent_phone_note: "Ota-ona telefon raqami bilan kiradi — pochta u uchun majburiy emas.",
    cab_email_real_note: "Pochta haqiqiy bo‘lishi kerak: hisob yaratilishidan oldin domen tekshiriladi.",
    cab_my_children: "Mening farzandlarim",
    cab_no_children: "Bu hisobga hali birorta o‘quvchi bog‘lanmagan — buni ma‘muriyat qiladi.",
    cab_add: "Qo‘shish",
    cab_save: "Saqlash",
    cab_mark_present: "Keldi",
    cab_mark_missed: "Kelmadi",
    cab_mark_note: "Darsni belgilash paketdan bitta darsni ayiradi — kelgan bo‘lsa ham, kelmagan bo‘lsa ham.",
    cab_lesson_time: "Vaqt",
    cab_lesson_course: "Kurs",
    cab_lesson_course_none: "Yakka dars",
    cab_scheduled_that_day: "O‘sha kuni jadval bo‘yicha: {times}.",
    cab_mark_same_day_note: "O‘quvchining bir kunda beshtagacha darsi bo‘lishi mumkin, turli kurslar bo‘yicha ham. Har birining vaqtini ko‘rsating — vaqtsiz ular bitta dars hisoblanadi va ikkinchi belgi birinchisini tuzatib qo‘yadi.",
    cab_mark_debt_note: "Ikkita to‘lanmagan darsi bor o‘quvchi darsga qo‘yilmaydi va ma‘muriyat to‘lovni kiritmaguncha darsni belgilab bo‘lmaydi.",
    cab_debt_title: "Qarz",
    cab_debt_lessons: "{n} ta to‘lanmagan dars",
    cab_debt_none: "To‘langan",
    cab_debt_blocked: "To‘lov qilinmaguncha darsga qo‘yilmaydi.",
    cab_debt_not_admitted: "qo‘yilmaydi",
    cab_debt_warn: "Yana {left} ta to‘lanmagan dars — va o‘quvchi darsga qo‘yilmaydi.",
    cab_current_password: "Joriy parol",
    cab_new_password: "Yangi parol",
    cab_password_changed: "Parol o‘zgartirildi. Qaytadan kiring.",
    cab_no_access: "Bu bo‘lim sizning rolingiz uchun mavjud emas.",
    cab_needs_login: "Kabinetni ochish uchun tizimga kiring.",

    // Administrator kabineti
    cab_pick_student: "O‘quvchi",
    cab_search: "Qidiruv",
    cab_delete: "Olib tashlash",
    cab_app_delete_confirm: "Butunlay o‘chirish",
    cab_cancel: "Bekor qilish",
    nf_title: "Bunday sahifa yo‘q",
    nf_text: "Manzil noto‘g‘ri yoki sahifa ko‘chirilgan. Hech nima buzilmagan — quyidagilardan birini tanlang.",
    nf_home: "Bosh sahifa",
    nf_courses: "Barcha kurslar",
    cab_tab_catalogue: "Katalog",
    cab_edit: "O‘zgartirish",
    cab_cat_courses: "Kurslar",
    cab_cat_teachers: "O‘qituvchilar",
    cab_cat_prices: "Narxlar",
    cab_cat_reviews: "Sharhlar",
    cab_cat_results: "Natijalar",
    cab_cat_live_note: "Bu — ochiq sayt. Bu yerda saqlangan hamma narsani tashrifchilar darhol ko‘radi.",
    cab_cat_confirm_delete: "Ha, o‘chirilsin",
    cab_cat_add_course: "Kurs qo‘shish",
    cab_cat_edit_course: "Kursni o‘zgartirish",
    cab_cat_title: "Nomi",
    cab_cat_category: "Turkum",
    cab_cat_icon: "Belgi",
    cab_cat_duration: "Davomiyligi",
    cab_cat_levels: "Darajalar",
    cab_cat_price_individual: "Narxi, yakka tartibda",
    cab_cat_description: "Tavsif",
    cab_cat_audience: "Kimlar uchun",
    cab_cat_program: "Dastur, har qatorga bittadan",
    cab_cat_formats: "Formatlar, har qatorga bittadan",
    cab_cat_note: "Izoh",
    cab_cat_add_teacher: "O‘qituvchi qo‘shish",
    cab_cat_edit_teacher: "Profilni o‘zgartirish",
    cab_cat_experience: "Tajriba",
    cab_cat_age_min: "Yosh (dan)",
    cab_cat_age_max: "Yosh (gacha)",
    cab_cat_age_max_hint: "cheklovsiz",
    cab_cat_photo: "Surat, havola",
    cab_cat_subject: "Fan",
    cab_cat_education: "Ma‘lumoti",
    cab_cat_short_bio: "Qisqa tarjimai hol, kartochka uchun",
    cab_cat_full_bio: "To‘liq tarjimai hol, profil uchun",
    cab_cat_certifications: "Sertifikatlar, har qatorga bittadan",
    cab_cat_achievements: "Yutuqlar, har qatorga bittadan",
    cab_cat_bio_note: "Inglizchasi majburiy: ruscha yoki o‘zbekcha matn yozilmaguncha tashrifchi aynan shuni ko‘radi. Sertifikatlar tarjima qilinmaydi — bu sertifikatlarning o‘z nomlari.",
    cab_cat_missing_langs: "yo‘q: {langs}",
    cab_cat_course: "Kurs",
    cab_cat_group: "Guruh",
    cab_cat_mini_group: "Mini-guruh",
    cab_cat_individual: "Yakka tartibda",
    cab_cat_reviews_note: "Sharhni sayt tashrifchisi yozadi va bu yerda chop etilmaguncha uni hech kim ko‘rmaydi.",
    cab_cat_published: "chop etilgan",
    cab_cat_waiting: "kutmoqda",
    cab_cat_publish: "Chop etish",
    cab_cat_results_note: "Faqat haqiqiy, tasdiqlangan natijalar — har biri bosh sahifada o‘quvchi ismi bilan chiqadi.",
    cab_cat_add_result: "Natija qo‘shish",
    cab_cat_result: "Natija",
    cab_cat_certificate: "Sertifikat, havola",
    cab_weekday: "Kun",
    cab_time: "Vaqt",
    cab_format: "Format",
    cab_teacher: "O‘qituvchi",
    cab_note: "Izoh",
    cab_start: "Boshlanish sanasi",
    cab_lessons_count: "Paketdagi darslar",
    cab_parents: "Ota-onalar",
    cab_link_parent: "Ota-onani biriktirish",
    cab_rate_per_lesson: "Bir dars uchun stavka",
    cab_tax_percent: "Ushlab qolish, %",
    cab_group_name: "Guruh nomi",
    cab_members: "Tarkib",
    cab_add_member: "O‘quvchi qo‘shish",
    cab_set_password: "Parol belgilash",
    cab_format_group: "guruh",
    cab_format_individual: "individual",
    cab_saved: "Saqlandi",
    cab_records: "Yozuvlar",
    cab_no_student_picked: "Qabulni ko‘rish va o‘zgartirish uchun o‘quvchini tanlang.",
    cab_rates: "O‘qituvchilar to‘lovi",
    cab_contract_hint: "Tugash sanasi boshlanish va muddatdan kelib chiqadi — birortasini o‘zgartirsangiz, u ham suriladi.",
    cab_contract_term_months: "Muddat, oy",
    cab_months_short: "oy",
    cab_contract_price: "Oylik narx",
    cab_contract_discount: "Chegirma, %",
    cab_contract_per_week: "Haftasiga darslar",
    cab_contract_per_month: "Oyiga darslar",
    cab_contract_note: "Izoh",
    cab_contract_due: "Oyiga to‘lanadi",
    cab_contract_edit: "O‘zgartirish",
    cab_contract_save: "Saqlash",
    cab_contract_cancel: "Bekor qilish",
    cab_contract_not_set: "kelishilmagan",
    cab_week_one: "marta haftasiga",
    cab_week_few: "marta haftasiga",
    cab_week_many: "marta haftasiga",
    cab_lesson_one: "dars oyiga",
    cab_lesson_few: "dars oyiga",
    cab_lesson_many: "dars oyiga",
    cab_package_hint: "Standart paket — 12 dars. Shartnoma muddatidan alohida hisoblanadi.",

    // Parolni topshirish
    cab_show: "Ko‘rsatish",
    cab_hide: "Yashirish",
    cab_copy: "Nusxalash",
    cab_copied: "Nusxalandi",
    cab_generate: "Yaratish",
    cab_new_account: "Hisob yaratildi. Ma‘lumotlarni hozir bering — parol qaytarib bo‘lmaydigan tarzda saqlanadi va keyin ko‘rib bo‘lmaydi.",
    cab_password_note: "Parolni keyinchalik hech kim ko‘ra olmaydi. Yo‘qolgan bo‘lsa — shu yerda yangisini belgilang.",
    cab_account_for: "Hisob egasi",

    // Ketganlar
    cab_filter_all: "Hammasi",
    cab_filter_active: "O‘qiyapti",
    cab_filter_left: "Ketgan",
    cab_left: "ketgan",
    cab_active_children: "farzandi o‘qiydi",
    cab_no_active_children: "farzandlari endi o‘qimaydi",
    cab_leaving_note: "Ketish hisobni o‘chirish orqali rasmiylashtiriladi: odam kira olmaydi va o‘qituvchilar ro‘yxatidan chiqadi, to‘lovlar, davomat va shartnomalar esa hisobotda qoladi. Hech narsa o‘chirilmaydi — o‘quvchi qaytsa, hammasi joyida.",
    cab_parent_orphan_note: "Farzandi endi o‘qimaydigan ota-onalarni ham o‘chirib qo‘ygan ma‘qul.",
    cab_schedule_group: "Butun guruhga qo‘yish",

    // Arizalar
    cab_tab_applications: "Arizalar",
    cab_app_new: "Yangi",
    cab_app_contacted: "Qo‘ng‘iroq qilindi",
    cab_app_enrolled: "Qabul qilindi",
    cab_app_declined: "Rad etildi",
    cab_app_trial: "Sinov darsi",
    cab_app_phone: "Telefon",
    cab_app_course: "Kurs",
    cab_app_wants: "Maqsad",
    cab_app_when: "Qulay kun va vaqt",
    cab_app_enrol: "O‘quvchi yaratish",
    cab_app_handled_by: "kim ko‘rdi",
    cab_app_note: "Qanday o‘tdi",
    cab_app_hint: "Ariza shu yerda o‘quvchiga aylanadi: tugma hisob yaratadi va arizani qabul qilingan deb belgilaydi. Qolgani — «O‘quvchilar» bo‘limida.",
    cab_app_created: "O‘quvchi yaratildi, ariza qabul qilingan deb belgilandi.",

    // Jurnal
    cab_tab_journal: "Jurnal",
    cab_journal_hint: "O‘quvchining ishlari: davomat, uyga vazifa va izohlar. O‘qituvchi, ota-ona va ma‘muriyat ko‘radi; o‘quvchining o‘zi ko‘rmaydi.",
    cab_notes: "Izohlar",
    cab_add_note: "Izoh qo‘shish",
    cab_note_text: "Nimani qayd etish",
    cab_note_private: "Izohlar o‘quvchiga ko‘rsatilmaydi.",
    cab_hw_done: "topshirilgan",
    cab_hw_missing: "topshirilmagan",
    cab_hw_set: "berilgan",
    cab_journal_no_student: "Hozircha ko‘rsatadigan o‘quvchi yo‘q.",
    cab_author: "muallif",

    // Sayt o‘qituvchilari
    cab_site_teachers: "Saytdagi o‘qituvchilar",
    cab_site_teachers_hint: "Bular tashrifchilar ko‘radigan kartochkalar. Kartochka — hisob emas: uni kabinet foydalanuvchisi bilan bog‘lang.",
    cab_no_account: "kabinetda hisob yo‘q",
    cab_linked_to: "bog‘langan",
    cab_link: "Bog‘lash",
  }
};

// Russian picks one of three forms by the last digits — 1 программа,
// 2 программы, 5 программ, and 11-14 take the third form despite ending in
// 1-4. English and Uzbek keep one form after a numeral, so only Russian keys
// are suffixed. Both counted phrases on the site (years of experience, the
// catalogue subtitle) go through this.
export const ruPluralSuffix = (n) => {
  const d10 = n % 10, d100 = n % 100;
  if (d10 === 1 && d100 !== 11) return 'one';
  if (d10 >= 2 && d10 <= 4 && (d100 < 12 || d100 > 14)) return 'few';
  return 'many';
};

export const useT = (lang) => (key, vars) => {
  const text = translations[lang]?.[key] ?? translations.en[key] ?? key;
  if (!vars) return text;
  return Object.keys(vars).reduce(
    (out, name) => out.split('{' + name + '}').join(vars[name]),
    text
  );
};
